import { Tabs } from "antd";
import * as React from "react";
import { Link } from "react-router-dom";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import * as styles from "./MenuTabs2.module.less";

export type MenuTab2Item = {
  label: string;
  page: PageUrl;
  params?: Record<string, string>;
};

type PropsMenuTabs2<T extends string> = {
  activeTab: T;
  tabs: Record<T, MenuTab2Item>;
};

export const MenuTabs2 = <T extends string>({
  activeTab,
  tabs,
}: PropsMenuTabs2<T>) => {
  const items = React.useMemo(
    () =>
      (Object.entries(tabs) as [string, MenuTab2Item][]).map(
        ([key, { label, page, params }]) => ({
          key,
          label:
            key === activeTab ? (
              label
            ) : (
              <Link to={makeUrl(page, params)}>{label}</Link>
            ),
        }),
      ),
    [tabs, activeTab],
  );

  return (
    <div className={styles.tabs}>
      <Tabs activeKey={activeTab} items={items} />
    </div>
  );
};
